import RoleAwareLink from '../../common/RoleAwareLink';
import { t } from '../../../modules/infra/i18n';

const NewCampaign = () => (
  <div className="o-flexbox">
    <RoleAwareLink
      to="/engagement/new"
      className="c-btn c-btn--medium c-btn--header u-ml- medium-and-down-ml0"
      data-automation-id="button:createCampaign"
    >
      {t('engage:buttons.create')}
      <div className="c-engagement-mobile-not-displayed"> {t('engage:buttons.campaign')}</div>
    </RoleAwareLink>
  </div>
);

export default NewCampaign;
